import type { ChartOptions } from 'chart.js';
import { formatUsd } from '@dapp/multi-lib/lib/formatters';

interface ChatParams {
  title: string;
}

export const buildChartOptions = (params: ChatParams): ChartOptions<'pie'> => {
  const { title } = params;

  return {
    responsive: true,
    borderColor: '#1b1d1e',
    layout: {
      padding: {
        bottom: 10,
      },
    },
    plugins: {
      tooltip: {
        callbacks: {
          title: function () {
            return '';
          },
          label: function (context) {
            const value = context.parsed;
            const sum = context.dataset.data.reduce((a, b) => a + b, 0);
            const percentage = ((value / sum) * 100).toFixed(2);

            return `${context.label}: $${formatUsd(value)} (${percentage}%)`;
          },
        },
      },
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: title,
        position: 'top' as const,
        color: '#ffffff',
        font: {
          size: 16,
        },
      },
    },
  };
};

const TOKEN_COLORS: Record<string, string> = {
  ETH: '#627EEA',
  WETH: '#8AA2F8',
  BNB: '#F3BA2F',
  USDC: '#2775CA',
  EURC: '#16A34A',
  BTC: '#F7931A',
  cbBTC: '#FF9F1C',
};

function hashString(input: string): number {
  let hash = 0;

  for (let i = 0; i < input.length; i++) {
    hash = input.charCodeAt(i) + ((hash << 5) - hash);
    hash |= 0;
  }

  return Math.abs(hash);
}

function hslColor(h: number, s = 68, l = 52): string {
  return `hsl(${h}, ${s}%, ${l}%)`;
}

export function getTokenColor(symbol: string, index?: number): string {
  const predefined = TOKEN_COLORS[symbol];
  if (predefined) return predefined;

  const baseHue = hashString(symbol) % 360;
  const hue = index === undefined ? baseHue : (baseHue + index * 37) % 360;

  return hslColor(hue);
}
